import * as React from 'react';
import * as classnames from 'classnames';
import { categoryIconMap, SportIconType } from 'eTip--common';
import { SportIcon } from 'common--design-library';


export interface ICategoryIconProps {
    categoryIconId?: number;
    className?: string;
    small?: boolean;
}


export const CategoryIcon: React.FC<ICategoryIconProps> = (props) => {
    let iconType = SportIconType.Universal;
    if (props.categoryIconId && categoryIconMap[props.categoryIconId]) {
        iconType = categoryIconMap[props.categoryIconId];
    }
    return <SportIcon
        className={classnames(props.className, { "icon-small": props.small })}
        type={iconType}
    />
}
